import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Twitch, Youtube } from 'lucide-react';
const creators = [{
  name: 'Torben Vex',
  specialty: 'Motocross Gaming',
  image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=2070&auto=format&fit=crop',
  followers: '2.4M'
}, {
  name: 'Isolde Rask',
  specialty: 'Snowboard Sim Champion',
  image: 'https://images.unsplash.com/photo-1565992441121-4367c2967103?q=80&w=1974&auto=format&fit=crop',
  followers: '1.8M'
}, {
  name: 'Caspian Thorne',
  specialty: 'Street Racing Elite',
  image: 'https://images.unsplash.com/photo-1533107862482-0e6974b06ec4?q=80&w=2000&auto=format&fit=crop',
  followers: '3.1M'
}];
export function Creators() {
  return <section className="bg-neutral-950 py-24 overflow-hidden" data-id="element-9">
      <div className="container mx-auto px-4" data-id="element-10">
        <div className="text-center mb-20" data-id="element-11">
          <h2 className="text-4xl md:text-7xl font-black text-white uppercase italic tracking-tighter mb-6" data-id="element-12">
            The{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-neutral-500" data-id="element-13">
              Elite
            </span>
          </h2>
          <p className="text-red-600 font-bold tracking-widest uppercase" data-id="element-14">
            Featured Creators
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-15">
          {creators.map((creator, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="group relative h-[500px] w-full overflow-hidden bg-neutral-900" data-id="element-16">
              {/* Image */}
              <div className="absolute inset-0" data-id="element-17">
                <img src={creator.image} alt={creator.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-18" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-90" data-id="element-19" />
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 w-full p-8 z-10" data-id="element-20">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-21">
                  <h3 className="text-3xl font-black text-white uppercase italic mb-1" data-id="element-22">
                    {creator.name}
                  </h3>
                  <p className="text-red-500 font-bold uppercase text-sm tracking-wider mb-4" data-id="element-23">
                    {creator.specialty}
                  </p>

                  <div className="flex items-center justify-between opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100 border-t border-neutral-800 pt-4" data-id="element-24">
                    <span className="text-white font-mono" data-id="element-25">
                      {creator.followers} Fans
                    </span>
                    <div className="flex gap-3" data-id="element-26">
                      <Twitch className="w-5 h-5 text-neutral-400 hover:text-white cursor-pointer transition-colors" data-id="element-27" />
                      <Youtube className="w-5 h-5 text-neutral-400 hover:text-white cursor-pointer transition-colors" data-id="element-28" />
                      <Instagram className="w-5 h-5 text-neutral-400 hover:text-white cursor-pointer transition-colors" data-id="element-29" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Decorative Border */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-red-600/50 transition-colors duration-300 pointer-events-none" data-id="element-30" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}